import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { useLive } from '../../live.jsx';
import RequestCard from './RequestCard.jsx';
import './requests.css';

// Seller dashboard: "Demandes qui correspondent à vos produits" — open
// requests in the categories of my live products.
export default function MatchingRequests() {
  const { t, lang } = useI18n();
  const [data, setData] = useState(null);
  const [tick, setTick] = useState(0);
  useLive(['requests'], () => setTick((x) => x + 1));
  useEffect(() => { api(`/my/buying-requests/matching?limit=6&lang=${lang}`).then(setData).catch(() => setData(null)); }, [lang, tick]);
  if (!data) return null;
  return (
    <section className="card" id="matching-requests" aria-labelledby="dash-matching">
      <div className="acc-section-title">
        <h2 className="acc-card-title" id="dash-matching"><span className="wanted-badge">{t('buying.wanted')}</span> {t('buying.matching.title')}</h2>
        <Link to="/marketplace?tab=requests" className="small">{t('buying.matching.seeAll')} →</Link>
      </div>
      {!data.hasProducts && <p className="muted">{t('buying.matching.noProducts')}</p>}
      {data.hasProducts && !data.items.length && <p className="muted">{t('buying.matching.empty')}</p>}
      {data.items.length > 0 && (
        <div className="req-grid">
          {data.items.map((r) => <RequestCard key={r.id} request={r} extra={r.myOfferStatus ? <span className={`chip-status offer-status-${r.myOfferStatus}`}>{t('buying.matching.offered')} · {t(`buying.offerStatus.${r.myOfferStatus}`)}</span> : null} />)}
        </div>
      )}
      <p className="muted small" style={{ marginBottom: 0 }}>{t('buying.sellerDigest')}</p>
    </section>
  );
}
